import TextBox from "devextreme-react/text-box";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import { formItemApi } from '../../../api/formItemApi';
import { formRegisterApi } from '../../../api/formRegisterApi';
import { DefaultButton, PrimaryButton } from '../../../components/editor/button';
import { useCommonContext } from '../../../contexts/common';
import { showNotify } from '../../../helpers/toast';
import { SelectBox } from 'devextreme-react';
import _ from 'lodash'
const AddCampaignModal = ({ selectedRowKeys, ts_form_register_result_details, dm_chiendichs, onSuccess, onCancel, ts_form_register_results }) => {
    const { translate } = useCommonContext();
    const { dm_coso_id } = useSelector((x) => x.coSo);
    const { nam_hoc } = useSelector(x => x.namHoc)
    const [ chiendichs, set_chiendichs] = useState([]);

    const _dataSource = useMemo(() => {
        return ts_form_register_result_details.filter((val) => selectedRowKeys.includes(val.ts_form_register_result_id));
    }, [ts_form_register_result_details, selectedRowKeys])
    const [formData, setFormData] = useState({
        dm_chiendich_id: 0,
    });

    useEffect(() => {
        const _listData = dm_chiendichs.filter(
          (y) => y.dm_coso_id == dm_coso_id
        );
        const _listData2 = _listData.filter(
          (y) => y.nam_hoc == nam_hoc
        );
        // console.log(_listData2);
        set_chiendichs(_listData2);
      }, [dm_chiendichs]);

    const [isSaving, setIsSaving] = useState(false);
    const { trigger, errors } = useForm();
    const handleSaveChanges = async () => {
        trigger().then(async (isValid) => {
            if (isValid && formData.dm_chiendich_id > 0) {
                const campaign = chiendichs.find(x => x.id == formData.dm_chiendich_id);
                if (campaign) {
                    const res = await formItemApi.Select(campaign.ts_form_id);
                    if (res.is_success) {
                        const items = res.data.filter((val) => val.is_show === true);
                        selectedRowKeys.forEach(element => {
                            const resgister = ts_form_register_results.find(x => x.id == element);
                            if(resgister && resgister.dm_chiendich_id != formData.dm_chiendich_id){
                                const _listData = _dataSource.filter(
                                    (y) => y.ts_form_register_result_id == element
                                );
                                var rs = [];
                                items.forEach(element => {
                                    const item = _listData.find((val) => val.ts_form_editor_id === element.ts_form_editor_id);
                                    if(item){
                                        var it = {
                                            ts_form_item_id: element.id,
                                            value: item.text,
                                            ts_form_editor_id: element.ts_form_editor_id,
                                        };
                                        rs.push(it);
                                    }
                                });
    
                                formRegisterApi.Insert({
                                    dm_chiendich_id: formData.dm_chiendich_id,
                                    ts_form_id: campaign.ts_form_id,
                                    phone_number: "",
                                    is_attendanced: false,
                                    result: rs,
                                });
                            }
                            
                        });
                    }
                }
                showNotify({ text: translate('Thêm vào chiến dịch thành công '), type: 'success' });
                onSuccess();
            }else{
                showNotify({ text: 'Vui lòng chọn chiến dịch', type: 'error' });
            }
        });
    };
    return (
        <div>
            <Modal
                open={true}
                size='small'
                dimmer={'blurring'}
                onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>{<p>{translate('Thêm vào chiến dịch')}</p>}</Modal.Header>
                <Modal.Content>
                    <form className='ui'>
                        <div className="row" >
                            <div className="col-md-12 padding-top-1rem">
                                <div className="dx-field-label">Chiến dịch</div>
                                <br></br>
                                <SelectBox
                                    dataSource={chiendichs}
                                    displayExpr={'ten_chien_dich'}
                                    valueExpr={'id'}
                                    value={formData.dm_chiendich_id}
                                    stylingMode="outlined"
                                    // width={width}
                                    searchEnabled
                                    placeholder={translate('Chọn chiến dịch')}
                                    showClearButton={true}
                                    onValueChanged={(e) => {
                                        setFormData((prev) => ({ ...prev, dm_chiendich_id: e.value }));

                                    }}
                                />
                                <br></br>
                                <br></br>
                            </div>
                        </div>
                    </form>
                </Modal.Content>
                <Modal.Actions>
                    <div>
                        <DefaultButton text={'Đóng'} onClick={onCancel} />
                        <PrimaryButton text={'Lưu'} onClick={handleSaveChanges} isLoading={isSaving} />


                    </div>
                </Modal.Actions>
            </Modal>
        </div>
    );
};
export default AddCampaignModal;
